import $util from './util.js';

/**
 * 默认的属性
 */
const defaultProps = {
    //url: 'ws://192.168.8.108:23456', // 连接地址
    url: `wss://${window.ip}:23456`, // 连接地址
    param: {}, // 连接参数
    maxRetryTimes: 3, // 最大失败重连次数
    sendInterval: 100 // 发送间隔，默认100ms
}

class SendQueue {
    constructor(props) {
        this.props = props;
        this.queue = [];
        this.state = {
            running: false
        };
    }

    push(data) {
        this.queue.push(data);
        if (this.queue.length > 0 && !this.state.running) {
            this.state.running = true;
            this.process();
        }
    }

    clear() {
        this.queue.length = 0;
        this.state.running = false;
    }

    process() {
        const { props, socket, state } = this.props.client;
        if (state.closed || socket.readyState !== WebSocket.OPEN) {
            setTimeout(() => {
                console.log('NettyClient 仍处于关闭状态，等待队列中发送，当前队列大小： ' + this.queue.length);
                this.process();
            }, 1000);
        } else {
            if (this.queue.length === 0) {
                this.state.running = false;
                return;
            }
            socket.send(this.queue.shift());
            console.log('队列中的数据包发送成功，当前队列大小：' + this.queue.length);
            setTimeout(() => this.process(), props.sendInterval);
        }
    }
}

export default class NettyClient {

    defaultEventHandlers = {
        'ack': msg => {
            if (msg.headers.status !== '200')
                this.ackPool[msg.ack].reject(msg);
            else {
                this.ackPool[msg.ack].resolve(msg);
                delete this.ackPool[msg.ack];
            }
        },
        'BROADCAST': msg => {
            alert('Received broadcast msg: ', msg.content);
        }
    }

    constructor(props) {
        this.props = Object.assign({}, defaultProps, props);
        // websocket实例
        this.socket = null;
        // 订阅列表及其回调，形式： 'topic-test': (msg) => { // do something }
        this.subscriptions = { 'topic-test': msg => console.log(msg) }
        // ack确认机制的promise池，形式：'generated-ack': {resolve, reject ...}
        this.ackPool = { 'generated-ack': {} };
        // 事件处理器池
        this.eventHandlers = this.defaultEventHandlers;
        // 消息发送队列
        this.sendQueue = new SendQueue({ client: this });
        // 状态池
        this.state = {
            closed: true,
            retriedTimes: 0
        }
        this.init();
    }

    /**
     * 初始化NettyClient
     * @returns Promise对象
     */
    async init() {
        this.destroy();
        const { maxRetryTimes } = this.props;
        console.log("初始化NettyClient");
        try {
            let opmes = await this.open();
            console.log(opmes);
            this.state.closed = false;
            let message = await this.bind();
            console.log(message);
            console.log("NettyClient 创建...");
            //
            // await this.open();
            // this.state.closed = false;
            // await this.bind();
        } catch (e) {
            console.error(`NettyClient 创建失败，原因是 ${JSON.stringify(e)}, 正在重试...`);
            this.state.retriedTimes = this.state.retriedTimes + 1;
            if (this.state.retriedTimes <= maxRetryTimes) this.init();
            else console.error('NettyClient 重试 maxRetryTimes，但仍然无法连接到服务器');
        }
    }

    /**
     * 打开连接
     * @returns 返回promise对象
     */
    open() {
        const { url, param, ...options } = this.props;
        return new Promise((resolve, reject) => {
            this.socket = new WebSocket(url + $util.extract2QueryUrl(param));
            // var ws = new WebSocket('ws://localhost:8080');
            //this.socket = new WebSocket('ws://192.168.158.13:12345'+ $util.extract2QueryUrl(param));
            this.socket.onopen = ev => {
                console.log("websocket连接成功")
                resolve(ev);
            };
            this.socket.onerror = ev => {
                console.log("websocket连接失败")
                reject(ev);
            }
        });
    }

    /**
     * 绑定消息收发处理器
     */
    bind() {
        return new Promise((resolve, reject) => {
            if (!this.socket && this.socket.readyState !== WebSocket.OPEN) reject('Socket 未初始化');
            this.socket.onclose = ev => {
                if (!this.state.closed) {
                    console.warn(`服务器关闭连接，正在重试连接...`);
                    this.init();
                } else {
                    this.destroy();
                }
            }
            this.socket.onmessage = ev => {
                const data = $util.parse(ev.data);
                const { command, topic } = data;
                if (this.eventHandlers[command]) this.eventHandlers[command](data);
                if (this.subscriptions[topic]) this.subscriptions[topic](data);
            }
            resolve();
        });
    }

    /**
     * 销毁NettyClient内部实例
     */
    destroy() {
        if (this.socket) this.socket.close();
        if (this.subscriptions) this.subscriptions = {};
        if (this.ackPool) this.ackPool = {};
        if (this.sendQueue) this.sendQueue.clear();
        this.socket = null;
        this.state = {
            closed: true
        }
    }

    /**
     * 事件处理器
     * @param eventName 事件名
     * @param callback 回调
     */
    on(eventName, callback) {
        this.eventHandlers[eventName] = callback;
    }

    /**
     * on方法的别名
     */
    addEventListener(eventName, callback) {
        this.on(eventName, callback);
    }

    /**
     * 内部传输方法
     */
    transport(eventName, content, contentType = 'text', headers) {
        let ack = $util.randomUUID();
        if (!content) console.warn('数据包中没有附加数据...');
        return new Promise((resolve, reject) => {
            this.ackPool[ack] = { ack, resolve, reject };
            this.sendQueue.push($util.toJsonStr({ ack, command: eventName, content, contentType, headers }));
        });
    }

    /**
     * transport 方法的别名
     */
    emit(eventName, content, contentType) {
        return this.transport(eventName, content, contentType);
    }

    /**
     * 内部主题传输方法
     */
    topicTransport(eventName, topic, content, contentType = 'text', headers) {
        let ack = $util.randomUUID();
        if (!content) console.warn('数据包中没有附加数据...');
        return new Promise((resolve, reject) => {
            this.ackPool[ack] = { ack, resolve, reject };
            this.sendQueue.push($util.toJsonStr({ ack, command: eventName, topic, content, contentType, headers }));
        });
    }

    /**
     * 内部点对点发送方法
     */
    p2pTransport(eventName, receiver, content, contentType = 'text', headers) {
        let ack = $util.randomUUID();
        if (!content) console.warn('数据包中没有附加数据...');
        return new Promise((resolve, reject) => {
            this.ackPool[ack] = { ack, resolve, reject };
            this.sendQueue.push($util.toJsonStr({ ack, receiver, command: eventName, content, contentType, headers }));
        });
    }

    /** 主动方法，向服务器发送数据 */
    /**
     * 发送连接请求，如果超时3分钟内未发送连接请求，将自动关闭连接
     * @param content 用户信息，提供用户id：{userId: 1}
     * @param headers 头信息，用于身份校验，暂不使用
     */
    connect(content, headers, userType) {
        return this.transport('CONNECT', content, headers, userType);
    }

    /**
     * 订阅主题
     * @param topic 主题名
     * @param callback 回调函数
     */
    subscribe(topic, callback) {
        this.subscriptions[topic] = callback;
        return this.topicTransport('SUBSCRIBE', topic);
    }

    /**
     * 取消订阅
     * @param topic 主题名
     */
    unsubscribe(topic) {
        return this.topicTransport('UNSUBSCRIBE', topic);
    }

    /**
     * 向主题发布信息
     * @param topic 主题名
     * @param content 数据
     * @param contentType 数据类型
     * @param headers 头信息，可以为空
     */
    publish(topic, content, contentType, headers) {
        return this.topicTransport('PUBLISH', topic, content, contentType, headers);
    }

    /**
     * 广播消息
     * @param content 数据
     * @param contentType 数据类型
     * @param headers 头信息，可以为空
     */
    broadcast(content, contentType, headers) {
        return this.transport('BROADCAST', content, contentType, headers);
    }

    /**
     * 点对点发送
     * @param receiver 接收者id
     * @param content 数据
     * @param contentType 数据类型
     * @param headers 头信息，可以为空
     */
    send(receiver, content, contentType, headers) {
        return this.p2pTransport('SEND', receiver, content, contentType, headers);
    }
}
